"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondaryButton = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var mona_1 = require("@artegeie/design-system/mona");
var SecondaryButton = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, onClick = _a.onClick, value = _a.value;
    return (0, jsx_runtime_1.jsx)(mona_1.Button, { label: value, style: 'outline', onClick: onClick, disabled: disabled }, void 0);
};
exports.SecondaryButton = SecondaryButton;
exports.default = exports.SecondaryButton;
